import notify from "devextreme/ui/notify"
import { useRef, useState } from "react"
import { useSelector } from "react-redux"
import { DataGrid, Modal } from "../../components"
import { DataGridButtonProps } from "../../components/data-grid/types"
import { getApiParams } from "../../redux/auth"
import { BodyType, createRequest } from "../../redux/base/request"
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga"
import { getLocalized } from "../../redux/localization"
import { adminContactsUrl } from "../../services/urls"
import AdminContactDetail from "./detail"
import { AdminContacts, CompleteContact } from "./type"

const Contact = () => {

    const [show, setShow] = useState(false)
    const localize = useSelector(getLocalized);
    const [data, setData] = useState<AdminContacts>({
        Email: "",
        Id: "",
        IsComplated: false,
        Message: "",
        Name: "",
        Phone: "",
        Surname: ""
    });
    const { token, lang } = useSelector(getApiParams);
    const completedId = useRef<CompleteContact>({
        contactId: ""
    })

    const columns = [
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "Surname",
            caption: localize.getString("surname")
        },
        {
            dataField: "Phone",
            caption: localize.getString("phone")
        },
        {
            dataField: "Email",
            caption: localize.getString("email")
        },
        {
            dataField: "Message",
            caption: localize.getString("message")
        },
        {
            dataField: "IsComplated",
            dataType : "boolean",
            caption: localize.getString("isComplated")
        }
    ]
    const buttons: DataGridButtonProps[] = [
        {
            hint: "info",
            icon: "info",
            onClick: async (e: any) => {
                completedId.current.contactId = e.row.data.Id
                const response: ApiResponse<AdminContacts> = await createRequest({
                    method: "GET",
                    url: "/api/admin/contacts/" + e.row.data.Id,
                    bodyType: BodyType.formdata,
                    token,
                    body: {},
                    lang,
                });
                if (verfiyResponse(response)) {
                    setData(response.Result)
                }
                setShow(true)
            },
        },
    ];
    return <>
        <Modal
            visible={show}
            onHiding={() => { setShow(false) }}
            title={localize.getString("contactDetail")}
            width="30%"
            buttonTitle="Tamamlandı"
            height="50%"
            onSubmitClick={async () => {
                const response: ApiResponse = await createRequest({
                    method: "POST",
                    url: "/api/admin/contacts",
                    bodyType: BodyType.raw,
                    token,
                    body: completedId.current,
                    lang,
                });
                if (verfiyResponse(response)) {
                    notify(response.Message, "success")
                    setShow(false)
                } else {
                    notify(response.Message, "danger")
                }
            }}>
            <AdminContactDetail data={data} complete={completedId.current}></AdminContactDetail>
        </Modal>
        <DataGrid
            url={adminContactsUrl}
            getByIdUrl={adminContactsUrl}
            columns={columns}
            buttons={buttons}
            refObject={{}}
            title="İletişim"
            sort={true}
        // details={{
        //     width: "30%",
        //     height: "50%",
        //     getByIdUrl: adminContactsUrl,
        //     title: localize.getString("contactDetail"),
        //     component: AdminContactDetail,
        // }}

        />
    </>
}

export default Contact;